export default __webpack_public_path__ + "static/media/p4.0aa2b105.png";